<!-- 申请 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单编号')">
              <a-input :placeholder="$t('请输入工单编号')" v-model="queryParam.ticketsNum"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('报装类型')">
              <a-select v-model="queryParam.ticketsType" :placeholder="$t('请选择报装类型')">
                <a-select-option :value="1">{{ $t('个人新装') }}</a-select-option>
                <a-select-option :value="6">{{ $t('企业新装') }}</a-select-option>
                <a-select-option :value="5">{{ $t('用水') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('工单紧急程度')">
              <j-dict-select-tag
                v-model="queryParam.ticketsEmergency"
                :placeholder="$t('请选择工单紧急程度')"
                dictCode="ticketsEmergency"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24" v-if="toggleSearchStatus">
            <a-form-item :label="$t('创建人员')">
              <a-select v-model="queryParam.createBy" :placeholder="$t('请选择创建人员')">
                <a-select-option value="微信端游客">{{ $t('微信端游客') }}</a-select-option>
                <a-select-option v-for="item in pList" :key="item.username" :value="item.username">{{
                  item.username
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('construction_detail')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" />{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div class="table-fixed">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :components="drag(columns)"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无图片') }}</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无文件') }}</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>

        <!-- 报装编号 -->
        <span slot="ticketsNum" slot-scope="text, record">
          <span>{{ text }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span @click.stop="copySampleNoLink(record.ticketsNum)" class="copySampleNo"><a-icon type="copy" /></span>
        </span>

        <span slot="ticketsEmergency" slot-scope="text, record">
          <a-tag color="red" v-if="text == 0">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="orange" v-else-if="text == 1">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="yellow" v-else-if="text == 2">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
          <a-tag color="blue" v-else-if="text == 3">{{ filterDictTextByCache('ticketsEmergency', text) }}</a-tag>
        </span>

        <span slot="action" slot-scope="text, record">
          <!-- <template v-if="(record.ticketsState== 0 && record.createBy == $store.getters.userInfo.username)||(record.ticketsState== 0 && userRoleCodes && userRoleCodes.includes('wxChuShen') && record.sourceType == 1)"> -->
          <template>
            <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
            <a-divider type="vertical" />
            <a-popconfirm :title="$t('确定开启吗?')" @confirm="() => handleStart(record)">
              <a>{{ $t('开启') }}</a>
            </a-popconfirm>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record, 'detail')">{{ $t('详情') }}</a>
                </a-menu-item>
                <a-menu-item>
                  <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                    <a>{{ $t('删除') }}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </template>
          <!-- <template v-else>
                        <a @click="handleDetail(record,'detail')">详情</a>
                    </template> -->
        </span>
      </a-table>
    </div>

    <construction-detail-modal ref="modalForm" @ok="modalFormOk"></construction-detail-modal>
    <EngineeringInstallationDetail
      ref="EngineeringInstallationDetailForm"
      @ok="modalFormOk"
    ></EngineeringInstallationDetail>
  </a-card>
</template>

<script>
import Vue from 'vue'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import ConstructionDetailModal from './modules/apply/ConstructionDetailModal'
import { postAction } from '@/api/manage'
import { filterDictTextByMany, filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import EngineeringInstallationDetail from '@/views/workOrderManagement/workManagement/modules/EngineeringInstallationDetail' //全部流程详情
import JInput from '@/components/jeecg/JInput'
import TableDragResize from '@/mixins/TableDragResize'

export default {
  name: 'ConstructionDetailList',
  mixins: [JeecgListMixin, mixinDevice, TableDragResize],
  components: {
    ConstructionDetailModal,
    EngineeringInstallationDetail,
    JInput,
  },
  data() {
    return {
      filterDictTextByCache: filterDictTextByCache,
      url: {
        list: '/jeecg-engineering/ticket/tickets/list',
        delete: 'jeecg-engineering/ticket/tickets/delete',
        deleteBatch: '/jeecg-engineering/ticket/tickets/deleteBatch',
        // exportXlsUrl: "/jeecg-engineering/engineering/installationDetail/exportXls",
        // importExcelUrl: "jeecg-engineering/engineering/installationDetail/importExcel",
        start: '/jeecg-engineering/ticket/tickets/startProcess/tickets',
      },
      dictOptions: {},
      superFieldList: [],
      queryParam: {
        workState: 0,
        belongModule: 'installation',
      },
      userRoleCodes: [],
    }
  },
  created() {
    this.getSuperFieldList()
    this.userRoleCodes = Vue.ls.get('userRoleCodes')
  },
  computed: {
    description() {
      return this.$t('construction_detail管理页面')
    },
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    // 表头
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('工单编号'),
          align: 'center',
          dataIndex: 'ticketsNum',
          width: 200,
          ellipsis: true,
          scopedSlots: { customRender: 'ticketsNum' },
        },
        // {
        //     title: '报装类型',
        //     align: "center",
        //     dataIndex: 'installationType',
        //     customRender: function (text) {
        //         return filterDictTextByCache('installationType', text)
        //     },
        //     width: 150,
        //     ellipsis: true,
        // },
        {
          title: this.$t('报装类型'),
          align: 'center',
          dataIndex: 'ticketsType',
          customRender: (t, r, index) => {
            if (t == 0) {
              return this.$t('换表')
            } else if (t == 1) {
              return this.$t('个人新装')
            } else if (t == 2) {
              return this.$t('故障报修')
            } else if (t == 3) {
              return this.$t('报停')
            } else if (t == 4) {
              return this.$t('复接')
            } else if (t == 6) {
              return this.$t('企业新装')
            } else if (t == 5) {
              return this.$t('用水')
            }
          },
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('工单紧急程度'),
          align: 'center',
          dataIndex: 'ticketsEmergency',
          // customRender: function (text) {
          //   return filterDictTextByCache('ticketsEmergency', text)
          // },
          scopedSlots: { customRender: 'ticketsEmergency' },
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('用户名称'),
          align: 'center',
          dataIndex: 'ticketsContact',
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t('用户电话'),
          align: 'center',
          dataIndex: 'ticketsContactPhone',
          width: 150,
          ellipsis: true,
        },
        // {
        //     title: '报装状态',
        //     align: "center",
        //     dataIndex: 'installationState',
        //     customRender: function (text) {
        //         return filterDictTextByCache('installationState', text)
        //     },
        //     width: 150,
        //     ellipsis: true,
        // },
        // {
        //     title: '当前任务',
        //     align: "center",
        //     dataIndex: 'currentNode',
        //     customRender: function (text) {
        //         return filterDictTextByCache('currentNode', text)
        //     },
        //     width: 150,
        //     ellipsis: true,
        // },
        {
          title: this.$t('当前节点处理人'),
          align: 'center',
          dataIndex: 'approverName',
          customRender: (text) => {
            if (text) {
              return text
            } else {
              return '/'
            }
          },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('申请人'),
          align: 'center',
          dataIndex: 'createBy',
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('申请时间'),
          align: 'center',
          dataIndex: 'createTime',
          width: 150,
          ellipsis: true,
        },
        // {
        //     title: '更新时间',
        //     align: "center",
        //     dataIndex: 'updateTime',
        //     width: 150,
        //     ellipsis: true,
        // },
        {
          title: this.$t('来源'),
          align: 'center',
          dataIndex: 'sourceType',
          customRender: (text) => {
            if(text == 1){
              return this.$t('小程序')
            }else if(text == 2){
              return this.$t('公众号')
            }else{
              return 'PC'
            }
          },
          width: 150,
          ellipsis: true,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  methods: {
    handleDetail(row) {
      this.$nextTick(() => {
        this.$refs.EngineeringInstallationDetailForm.init(row, false)
      })
    },
    searchReset() {
      this.queryParam = {
        workState: 0,
        belongModule: 'installation',
      }
      this.loadData()
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'installationId', text: '报装id' })
      fieldList.push({ type: 'string', value: 'companyId', text: '公司id' })
      fieldList.push({ type: 'int', value: 'isAcceptance', text: '是否需要验收' })
      fieldList.push({ type: 'string', value: 'projectDetail', text: '项目说明' })
      fieldList.push({ type: 'int', value: 'isDesignChanges', text: '是否存在设计变更' })
      fieldList.push({ type: 'string', value: 'constructionRemark', text: '施工备注' })
      fieldList.push({ type: 'int', value: 'ticketsEmergency', text: '工单紧急程度' })
      fieldList.push({ type: 'string', value: 'constructionAnnex', text: '施工附件' })
      fieldList.push({ type: 'string', value: 'acceptanceAnnex', text: '验收附件' })
      fieldList.push({ type: 'string', value: 'remark', text: '备注信息' })
      this.superFieldList = fieldList
    },
    // 开启
    handleStart(row) {
      this.loading = true
      postAction(this.url.start, { dataId: row.id, flowableKey: row.ticketsProcessKey }).then(res => {
        if (res.success) {
          this.$message.success(this.$t('开启成功'))
          this.loading = false
          this.loadData()
        } else {
          this.$message.error(this.$t('开启失败'))
          this.loading = false
        }
      })
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
